module.exports = __webpack_public_path__ + "fonts/8262e0c31d729ed3c08a9b31e337e406.ttf";